import { DIGISAKA_API_ORIGIN } from '../../../config/digisakaApiOrigin';
import { CROP_AREA_COLOR } from './cropAreaColor';

/** Philippines maize area. Class 1 is maize; 0 is not maize. */
export const MAIZE_CROP_COG_URL =
  'https://digisaka.s3.amazonaws.com/crop_area/philippines_maize_area_2021_100m_cog.tif';

/** Raster extent from TiTiler /info (EPSG:4326). */
export const MAIZE_CROP_BBOX: [number, number, number, number] = [
  116.9315, 4.6137, 126.6011, 21.1206,
];

const TITILER_TILE_BASE = DIGISAKA_API_ORIGIN + '/api/tiles/WebMercatorQuad/{z}/{x}/{y}@2x.png';

/** Drawn maize only. Class 0 is nodata so the basemap stays visible. */
export const MAIZE_CROP_COLOR = CROP_AREA_COLOR;

export const MAIZE_CROP_LEGEND = {
  colors: [MAIZE_CROP_COLOR],
  labels: ['Maize'],
  description: 'Maize areas',
};

export function buildMaizeCropTileUrl(cogUrl: string = MAIZE_CROP_COG_URL): string {
  const params = new URLSearchParams();
  params.set('url', cogUrl);
  params.set('bidx', '1');
  params.set('colormap', JSON.stringify({ '1': MAIZE_CROP_COLOR }));
  params.set('nodata', '0');
  params.set('resampling', 'nearest');
  return `${TITILER_TILE_BASE}?${params.toString()}`;
}
